import { getBanners } from "@/common/apis/getBanners";
import { MaintenanceBanner } from "@/common/constants/navisphereonline.common.api";
import React, { useEffect, useState } from "react";
import ErrorOutline from '@mui/icons-material/ErrorOutline';
import DOMPurify from "dompurify";
import { Box } from "@mui/material";
import "./MaintenanceBanner.scss";
import { IconButton } from "@chr/eds-react";

export const MaintenanceBanners = () => {
  const [banners, setBanners] = useState<MaintenanceBanner[]>([]);

  useEffect(() => {
    getBannersData();
    const interval = setInterval(() => {
      getBannersData();
    },60*1000);
    return () => clearInterval(interval);
  }, []);

  const getBannersData = () => {
    getBanners()
    .then((response) => {
      const bannersToDisplay: MaintenanceBanner[] = [];
      let closedBannersIds: number[] = JSON.parse(localStorage.getItem('closedBannerIds')!);

      if (!closedBannersIds) {
        closedBannersIds = [];
      }

      const now = new Date();
      response.banners.forEach((banner) => {
        const bannerStartDisplayTime = new Date(Date.parse(banner.fromDate + ' ' + banner.fromTime));
        const bannerEndDisplayTime = new Date(Date.parse(banner.toDate + ' ' + banner.toTime));

        if (closedBannersIds.indexOf(banner.id) === -1)
        {
          if (now >= bannerStartDisplayTime && now <= bannerEndDisplayTime) {
            bannersToDisplay.push(banner);
          }
        }
      });
      setBanners(bannersToDisplay);
    });
  }

  const hideMaintenanceBanner = (id: number) => {
    const closedBannerIds: number[] = [];
    const storageIds = JSON.parse(localStorage.getItem('closedBannerIds')!);
    closedBannerIds.push(id);

    if (storageIds) {
      closedBannerIds.push(...storageIds);
    }

    localStorage.setItem('closedBannerIds', JSON.stringify(closedBannerIds));
    const filteredBanners = banners.filter(banner => banner.id !== id);
    setBanners(filteredBanners);
  }

  return (
    <React.Fragment key="maintenance-banners">
      {
        banners.map((banner) => {
          return (
            <Box className="maintenance-banner-container" data-testid={`banner-container-${banner.id}`} key={`banner-${banner.id}`}>
              <Box className="icon-container">
                  <ErrorOutline
                  aria-label='Error Outlined Icon'
                  />
              </Box>
              <Box className="content-container">
                  <Box className="banner-topic" data-testid={`banner-topic-${banner.id}`}>
                      {banner.topic + ' : '}
                  </Box>
                  <Box className="banner-content" data-testid={`banner-content-${banner.id}`} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(banner.message)}} />
              </Box>
              <Box className="close-icon-container" data-testid={`banner-close-${banner.id}`}>
                <IconButton
                  aria-label="Close"
                  icon="close"
                  onClick={() => {hideMaintenanceBanner(banner.id)}}
                />
              </Box>
            </Box>
          );
        })
      }
    </ React.Fragment>
  );
}

export default MaintenanceBanners;